document.addEventListener("DOMContentLoaded", () => {
  const DURATION = 900;   // 15:00 — initial reservation window
  const FALLBACK = 300;   // 5:00  — restart duration after expiry

  let timerInterval = null;
  let cartHasLimited = false;

  // ─── Helpers ────────────────────────────────────────────────────

  function getTimerEl() {
    return document.getElementById("cart-timer");
  }

  function getWrapperEl() {
    return document.querySelector(".cart-timer__wrapper");
  }

  function formatTime(totalSeconds) {
    const m = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const s = String(totalSeconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  }

  // ─── Timer Core ─────────────────────────────────────────────────

  function startTimer(duration) {
    const display = getTimerEl();
    if (!display) return;

    clearInterval(timerInterval);

    // Restore from session, or start fresh with the given duration
    let remaining = parseInt(sessionStorage.getItem("cartTimer"), 10);
    if (isNaN(remaining) || remaining <= 0) {
      remaining = duration;
    }

    const tick = () => {
      display.textContent = formatTime(remaining);
      sessionStorage.setItem("cartTimer", remaining);

      if (remaining <= 0) {
        clearInterval(timerInterval);
        sessionStorage.removeItem("cartTimer");
        // Restart at fallback duration
        startTimer(FALLBACK);
        return;
      }

      remaining--;
    };

    tick(); // render immediately, then every second
    timerInterval = setInterval(tick, 1000);
  }

  function stopTimer() {
    clearInterval(timerInterval);
    timerInterval = null;
    sessionStorage.removeItem("cartTimer");
  }

  // ─── Show / Hide ─────────────────────────────────────────────────

  function showTimer() {
    const wrapper = getWrapperEl();
    if (!wrapper) return;
    wrapper.classList.remove("hidden");
    startTimer(DURATION);
  }

  function hideTimer() {
    const wrapper = getWrapperEl();
    if (wrapper) wrapper.classList.add("hidden");
    stopTimer();
  }

  // ─── Cart Check ──────────────────────────────────────────────────

  let checkDebounce = null;

  async function checkCartAndToggleTimer() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      cartHasLimited = cart.items.some(item =>
        item.product_title?.includes("Limited")
      );

      cartHasLimited ? showTimer() : hideTimer();
    } catch (err) {
      console.error("[cart-timer] Cart check failed:", err);
    }
  }

  function debouncedCheck(ms = 500) {
    clearTimeout(checkDebounce);
    checkDebounce = setTimeout(checkCartAndToggleTimer, ms);
  }

  // ─── Fetch Interceptor ───────────────────────────────────────────

  const CART_MUTATING = [
    "/cart/add",
    "/cart/change",
    "/cart/update",
    "/cart/clear",
  ];

  const _fetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await _fetch(...args);

    const url = typeof args[0] === "string" ? args[0] : args[0]?.url ?? "";
    if (CART_MUTATING.some(path => url.includes(path))) {
      debouncedCheck();
    }

    return response;
  };

  // ─── Cart Drawer Open ────────────────────────────────────────────

  document.addEventListener("theme:cart:open", () => {
    if (!cartHasLimited) return;

    const wrapper = getWrapperEl();
    if (!wrapper) return;

    wrapper.classList.remove("hidden");

    // Only restart the timer if it's not already running
    if (!timerInterval) {
      startTimer(DURATION);
    }
  });

  // ─── Init ────────────────────────────────────────────────────────

  checkCartAndToggleTimer();
});